<template>
  <div>
    <p class="title text-left">从传统超市到连锁创新，80后超市创二代的生意经！</p>
    <p class="desc text-left">2019-8-29　<span class="author">及时雨小额贷款</span></p>
    <div class="main-content text-left">
      <p class="normal">吴佟从小就知道，长大后有一家超市等着他去继承。他是浙江人，家里从爷爷辈开始，都是开超市的，这是他们的家族企业。</p>
      <p class="bold"><span>接手超市，接过爸爸肩上的重担</span></p>
      <p class="normal"><img src="../img/custDetail/6-01.png" width="100%" alt=""></p>
      <p class="normal">附近几个镇上都有他们家的超市，小时候出去玩，去哪里都有冷饮喝，那时他便萌发了开连锁超市的想法。</p>
      <p class="normal">读完大学后，他来超市帮忙，爸爸老吴亲自带他。管理超市的第一步是熟悉超市运作流程，从哪里进到又好又便宜的货品？商品怎么摆放？怎么拉回头客？他学的很认真。</p>
      <p class="normal">2年后，吴佟正式接管超市，“爸爸起早贪黑干了一辈子，这是他的心血，我得把超市经营的更好，才对得起他。”他默默许下心愿。</p>
      <p class="normal">从此老吴退休了，有时间也有钱，在儿子的鼓励下到处旅游，尝试新鲜玩意。</p>
      <p class="bold"><span>开连锁超市，实现小时候的梦想</span></p>
      <p class="normal"><img src="../img/custDetail/6-02.png" width="100%" alt=""></p>
      <p class="normal">吴佟的超市生意红火，但他有更大的期望。为了追求更好的生活环境，他带着妻子来到了上海。</p>
      <p class="normal">这座充满活力的城市，激发了他奋斗的热情。用在老家挣的钱，在金山区开了一家新超市。虽然店面只有50多平，但是人流量很大，每天的营业额还不错。</p>
      <p class="normal">吴佟为人热情健谈，总能拿到物美价廉的商品。慢慢的，他在上海开了5家分店。</p>
      <p class="bold"><span>旧店翻新，急需一笔资金</span></p>
      <p class="normal"><img src="../img/custDetail/6-03.png" width="100%" alt=""></p>
      <p class="normal">金山区的超市附近开了新楼盘，人流量更大了，他决定立马翻新门店，把旁边的店铺也租下来，扩大超市面积。</p>
      <p class="normal">手里的积蓄都投在了新开的超市里，翻新旧店，急需一笔能快速到账的钱，这时朋友推荐了及时雨小贷。</p>
      <p class="normal">吴佟在上海打拼十余年，不仅开了5家超市，还置办了5套房产，征信记录、财务状况良好。很快就通过了审核，拿到了80万的贷款金额。</p>
      <p class="normal">超市已经动工了，预计半个月后恢复营业，相信未来生意会更红火！</p>
      <p class="bold"><span>每个行业后都站着一个小微</span></p>
      <p class="normal">吴佟的故事只是众多小微故事的缩影，还有千千万万的小微企业面临资金短缺的境况，我们希望能在大家需要帮助的时候搭一把手，通过自己小小的举动，帮他人度过难关。</p>
    </div>
  </div>

</template>

<script>
  export default {
    name: "Detail6"
  }
</script>

<style scoped lang="less">
  @import "detail.less";
</style>



// WEBPACK FOOTER //
// src/components/Detail6.vue